<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import TcModal from "@/Components/UI/TcModal";

import useUserStore from "@/Modules/User/Store";

const { t } = useI18n();

const userStore = useUserStore();

const emit = defineEmits<{
  (event: "onClose"): void;
}>();

const textButton = computed(() => {
  if (userStore.getUserIsPatient) {
    return t("chat.modal.video_call_error.content.more_info.link_text_patient");
  } else {
    return t("chat.modal.video_call_error.content.more_info.link_text_therapist");
  }
});

const handleAccept = () => {
  if (userStore.getUserIsPatient) {
    window.open(t("chat.modal.video_call_error.content.more_info.link_href_patient"), "_blank");
  } else {
    window.open(t("chat.modal.video_call_error.content.more_info.link_href_therapist"), "_blank");
  }

  emit("onClose");
};
</script>

<template>
  <TcModal
    class="modal"
    :title="t('chat.modal.video_call_error.title')"
    :acceptButtonText="textButton"
    @clickOutside="() => emit('onClose')"
    @acceptButtonClicked="handleAccept"
  >
    <template #description>
      <p class="mb-4">{{ t("chat.modal.video_call_error.content.title") }}</p>

      <ul class="modal__list">
        <li>{{ t("chat.modal.video_call_error.content.step1") }}</li>
        <li>{{ t("chat.modal.video_call_error.content.step2") }}</li>
        <li>{{ t("chat.modal.video_call_error.content.step3") }}</li>
      </ul>

      <p>
        {{ t("chat.modal.video_call_error.content.more_info") }}
      </p>
    </template>
  </TcModal>
</template>

<style scoped lang="scss">
.modal {
  &__list {
    @include sp.padding(l, 8);
    @include sp.margin(b, 4);

    list-style: disc;
  }
}
</style>
